<template>
  <div>
    <common-nav></common-nav>
    <slot />
    <common-footer />
  </div>
</template>
<script>
import CommonFooter from '@/components/CommonFooter';
import CommonNav from '@/components/CommonNav';

export default {
  components: {
    CommonFooter,
    CommonNav
  },
  name: 'Default'
};
</script>
